import { Component, EventEmitter, Input, Output, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IconComponent } from '@navstation-portal/shared/ui/components';
import { IconNames } from '@navstation-portal/shared/data-model/ui';
import {
  ReorderAction,
  ReorderButtonsComponent,
} from '../reorder-buttons/reorder-buttons.component';
import { TrashButtonComponent } from '../trash-button/trash-button.component';
import { TankSummaryComponent } from './tank-summary/tank-summary.component';

@Component({
  selector: 're-tank-transfer',
  templateUrl: './tank-transfer.component.html',
  styleUrl: './tank-transfer.component.css',
  imports: [
    TankSummaryComponent,
    FormsModule,
    ReorderButtonsComponent,
    TrashButtonComponent,
    IconComponent,
  ],
})
export class TankTransferComponent implements OnInit {
  IconNames = IconNames;
  @Input({ required: true }) action: any;
  @Output() reorder = new EventEmitter<{ id: number; action: ReorderAction }>();
  @Output() delete = new EventEmitter<any>();

  progress2 = 0;
  progress3 = 0;

  transferAmount = 0;
  fromProgress = 0;
  toProgress = 0;

  get from() {
    return this.action.tanks[0];
  }

  get to() {
    return this.action.tanks[1];
  }

  onModelChange() {
    this.action.tankOperations = [
      {
        tank: {
          ...this.from,
        },
        fuel: {
          fuelGrade: this.from.content?.fuelGrade,
          quantity: -this.transferAmount,
        },
      },
      {
        tank: {
          ...this.to,
        },
        fuel: {
          fuelGrade: this.to.content?.fuelGrade,
          quantity: this.transferAmount,
        },
      },
    ];
  }

  onDelete() {
    this.delete.emit(this.action);
  }

  onReorder(action: any) {
    this.reorder.emit({
      id: this.action.id,
      action: action,
    });
  }

  onSwapTanks() {
    this.action.tanks.reverse();
    if (this.transferAmount > this.maxTransferAmount) {
      this.transferAmount = this.maxTransferAmount;
    }
    this.calculateProgress();
  }

  calculateProgress() {
    const fromCapacity = this.from.capacity ?? 0;
    const toCapacity = this.to.capacity ?? 0;
    const fromQuantity = this.from.content?.quantity ?? 0;
    const toQuantity = this.to.content?.quantity ?? 0;

    this.fromProgress =
      fromCapacity > 0
        ? ((fromQuantity - this.transferAmount) / fromCapacity) * 100
        : 0;

    this.toProgress = toCapacity > 0 ? (toQuantity / toCapacity) * 100 : 0;

    this.progress2 =
      fromCapacity > 0 ? (this.transferAmount / fromCapacity) * 100 : 0;
    this.progress3 =
      toCapacity > 0 ? (this.transferAmount / toCapacity) * 100 : 0;
  }

  ngOnInit() {
    this.calculateProgress();
  }

  get maxTransferAmount(): number {
    const fromQuantity = this.from.content?.quantity ?? 0;
    const toAvailCapacity =
      (this.to.capacity ?? 0) - (this.to.content?.quantity ?? 0);

    const max =
      fromQuantity <= toAvailCapacity ? fromQuantity : toAvailCapacity;
    return Math.max(0, max);
  }

  onInputChange(): void {
    this.calculateProgress();
  }
}
